import { makeActionCreator } from '../../utils/actionsUtils';
import { CHANGE_CURRENT_LOCALE } from './constants';

// change la langue courante du site
export const changeCurrentLocale = makeActionCreator(CHANGE_CURRENT_LOCALE, 'newState');



// WEBPACK FOOTER //
// ./src/services/i18n/actions.js